import Box from "@mui/material/Box";
import { when } from "util/support";
import { OnboardingPaymentMethod } from "ui/molecules/PaymentMethod";
import { Collection } from "ui/support/Resource";
import OnboardingForm from "ui/forms/Onboarding/OnboardingForm";
import {
    FormField,
    type PaymentMethod as PaymentMethodType,
    type OnboardingPaymentMethodsProps
} from "./types";
import OnboardingReviewableFormInput from "../../OnboardingReviewableFormInput";

export const PaymentMethods = ({
    values,
    isSubmitting,
    isValid,
    isBootstrapDataLoading,
    bootstrapData,
    setFieldValue,
    setFieldTouched,
    handleChange,
    handleBlur,
    handleSubmit,
    ...form
}: OnboardingPaymentMethodsProps) => (
    <OnboardingForm
        {...form}
        isSubmitting={isSubmitting}
        isValid={isValid}
        handleSubmit={handleSubmit}
    >
        <OnboardingReviewableFormInput
            sx={{
                alignItems: 'flex-start'
            }}
            name={FormField.Methods}
            values={values}
            renderLabel={() => 'Payment Methods'}
            setFieldValue={setFieldValue}
            setFieldTouched={setFieldTouched}
            renderFormInput={({ disabled, reviewableStatus }) => (
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: '1fr auto',
                        alignItems: 'flex-start',
                        gap: 1
                    }}
                >
                    <Collection
                        sx={{
                            display: 'grid',
                            gap: 1,
                            gridTemplateColumns: {
                                xs: '1fr',
                                md: '1fr 1fr'
                            }
                        }}
                        collection={bootstrapData.methods}
                        renderResource={(paymentMethod: PaymentMethodType, index) => {
                            const tags = values[FormField.Methods];
                            const isChecked = tags.includes(paymentMethod.tag);

                            return (
                                <OnboardingPaymentMethod
                                    {...paymentMethod}
                                    key={index}
                                    disabled={disabled}
                                    checked={isChecked}
                                    onChange={() => {
                                        when(
                                            isChecked,
                                            () => setFieldValue(
                                                FormField.Methods,
                                                tags.filter(tag => !Object.is(paymentMethod.tag, tag))
                                            ),
                                            () => setFieldValue(
                                                FormField.Methods,
                                                [...tags, paymentMethod.tag]
                                            )
                                        );

                                        setTimeout(() => setFieldTouched(FormField.Methods, true, true));
                                    }}
                                />
                            );
                        }}
                    />
                    <Box
                        sx={{
                            mt: 1
                        }}
                    >
                        {reviewableStatus}
                    </Box>
                </Box>
            )}
        />
    </OnboardingForm>
);

export default PaymentMethods;
